import React from 'react';
import { Shield, Clock, Star } from 'lucide-react';
import { companyInfo } from '../mock';

const About = () => {
  const trustBadges = [
    {
      icon: Shield,
      title: "Zuverlässig & termintreu",
      description: "Pünktlich zu jedem Termin"
    },
    {
      icon: Clock,
      title: "Schnelle Rückmeldung",
      description: "Antwort innerhalb 24h"
    },
    {
      icon: Star,
      title: "5,0 Sterne Bewertung",
      description: "Zufriedene Kunden"
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1733286125300-b4c5563295ad"
                alt="Stark Hausmeisterservice Team"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Ihr zuverlässiger Partner in Dillingen
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              {companyInfo.aboutText}
            </p>
            
            {/* Trust Badges */}
            <div className="space-y-4 mb-8">
              {trustBadges.map((badge, index) => {
                const IconComponent = badge.icon;
                return (
                  <div
                    key={index}
                    className="flex items-start space-x-4 p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                  >
                    <div className="bg-slate-900 rounded-lg p-3 flex-shrink-0">
                      <IconComponent className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="font-semibold text-slate-900 mb-1">
                        {badge.title}
                      </div>
                      <div className="text-slate-600 text-sm">
                        {badge.description}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Key Points */}
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl font-bold text-slate-900 mb-1">100+</div>
                <div className="text-slate-600 text-sm">Zufriedene Kunden</div>
              </div>
              <div className="text-center p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl font-bold text-slate-900 mb-1">24/7</div>
                <div className="text-slate-600 text-sm">Notfallservice</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
